"use client"
import { useState, useEffect } from "react";

function getWhere(): string[] {
  return ["China", "US", "UK"];
}

export default function Page() {
  const [where, setWhere] = useState<{ id: number; name: string }[]>([]);
  const [input, setInput] = useState("");
  const [idCounter, setIdCounter] = useState(0); // 用于生成唯一 id

  useEffect(() => {
    setWhere(getWhere().map((name, idx) => ({ id: idx, name })));
    setIdCounter(getWhere().length);
  }, []);

  const addWhere = () => {
    if (input.trim() === "") return;
    setWhere([{ id: idCounter, name: input.trim() }, ...where]);
    setIdCounter(idCounter + 1);
    setInput("");
  };

  const removeWhere = (id: number) => {
    setWhere(where.filter((w) => w.id !== id));
  };

  return (
    <>
      <div className="first-line font-bold text-3xl">
        <div>I come from</div>
        <div>
          <input
            className="the-where border p-1 rounded"
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") addWhere();
            }}
          />
        </div>
      </div>

      <div className="visit-list mt-4 space-y-1">
        {where.map((item) => (
          <div key={item.id} className="flex items-center space-x-2">
            <span>{item.name}</span>
            <span
              className="text-red-500 cursor-pointer"
              onClick={() => removeWhere(item.id)}
            >
              ❌
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
